var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  padding: 1.25em 0;\n  align-items: center;\n  &:not(:last-child) {\n    border-bottom: 1px solid ', ';\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  padding: 1.25em 0;\n  align-items: center;\n  &:not(:last-child) {\n    border-bottom: 1px solid ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['  \n  color: ', ';\n  font-family: ', ';\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.17px;\n  line-height: 18px;\n  width: 100%;\n'], ['  \n  color: ', ';\n  font-family: ', ';\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.17px;\n  line-height: 18px;\n  width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  width: 100%;\n  cursor: grab;\n'], ['\n  display: flex;\n  align-items: center;\n  width: 100%;\n  cursor: grab;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  font-size: 12px;\n  font-family: ', ';\n\n  @media(max-width: 540px) {\n    display: flex;\n    flex-direction: column;\n  }\n'], ['\n  position: relative;\n  font-size: 12px;\n  font-family: ', ';\n\n  @media(max-width: 540px) {\n    display: flex;\n    flex-direction: column;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  height: 48px;\n  width: 122.09px;\n  border: 1px solid ', ';\n  background-color: #FFFFFF;\n  padding: 14px;\n'], ['\n  height: 48px;\n  width: 122.09px;\n  border: 1px solid ', ';\n  background-color: #FFFFFF;\n  padding: 14px;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  height: 48px;\n  width: 104px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  background-color: ', ';\n  color: white;\n  cursor: pointer;\n\n  &:disabled,\n  &[disabled] {\n    background-color: ', ';\n  }\n'], ['\n  height: 48px;\n  width: 104px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  background-color: ', ';\n  color: white;\n  cursor: pointer;\n\n  &:disabled,\n  &[disabled] {\n    background-color: ', ';\n  }\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-content: center;\n  margin-bottom: 35px;\n  ', ' {\n    margin-left: 1em;\n  }\n\n  @media(max-width: 540px) {\n    flex-direction: column;\n    ', ' {\n      margin-left: 0;\n    }\n    & > * {\n      margin-bottom: 10px;\n      width: 100%;\n    }\n  }\n'], ['\n  display: flex;\n  align-content: center;\n  margin-bottom: 35px;\n  ', ' {\n    margin-left: 1em;\n  }\n\n  @media(max-width: 540px) {\n    flex-direction: column;\n    ', ' {\n      margin-left: 0;\n    }\n    & > * {\n      margin-bottom: 10px;\n      width: 100%;\n    }\n  }\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin: 0 8px;\n'], ['\n  margin: 0 8px;\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  &.fa.fa-trash-o {\n    cursor: pointer;\n    font-size: 22px;\n    color: ', ';\n  }\n'], ['\n  &.fa.fa-trash-o {\n    cursor: pointer;\n    font-size: 22px;\n    color: ', ';\n  }\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n\n  input {\n    height: 100%;\n    padding: 10px;\n  }\n  input::placeholder {\n    color: ', '\n  }\n'], ['\n  display: flex;\n  align-items: center;\n\n  input {\n    height: 100%;\n    padding: 10px;\n  }\n  input::placeholder {\n    color: ', '\n  }\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  &.fa-sm {\n    font-size: 12px;\n  }\n  margin-left: -20px;\n  margin-right: 5px;\n  cursor: pointer;\n'], ['\n  color: ', ';\n  &.fa-sm {\n    font-size: 12px;\n  }\n  margin-left: -20px;\n  margin-right: 5px;\n  cursor: pointer;\n']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n  &.fa.fa-bars {\n    color: ', ';\n    font-size: 22px;\n    margin-right: 20px;\n    cursor: grab;\n  }\n'], ['\n  &.fa.fa-bars {\n    color: ', ';\n    font-size: 22px;\n    margin-right: 20px;\n    cursor: grab;\n  }\n']),
    _templateObject14 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  padding: 8px 10px;\n  padding-bottom: 5px;\n\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  cursor: pointer;\n  padding: 8px 10px;\n  padding-bottom: 5px;\n\n  &:hover {\n    background-color: ', ';\n  }\n']),
    _templateObject15 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject16 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n'], ['\n  flex: 1;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import Theme from '../../../Theme';

export var List = styled.div(_templateObject);

export var ListItem = styled.div(_templateObject2, Theme.colors.pearlGrey);

export var ListItemLabel = styled.span(_templateObject3, Theme.colors.primary, Theme.fonts.Montserrat);

export var SortableHandlerBox = styled.span(_templateObject4);

export var SelectSortableBox = styled.div(_templateObject5, Theme.fonts.Montserrat);

export var Input = styled.div(_templateObject6, Theme.colors.pearlGrey);

export var Button = styled.button(_templateObject7, Theme.colors.lightBlue, Theme.colors.pearlGrey);

export var SelectBox = styled.div(_templateObject8, Button, Button);

export var ToBox = styled.span(_templateObject9);

export var To = function To() {
  return React.createElement(
    ToBox,
    null,
    'To'
  );
};

export var RemoveAction = styled.i.attrs(function (props) {
  return {
    className: 'fa fa-trash-o'
  };
})(_templateObject10, Theme.colors.blueGrey);

export var InputBox = styled.div(_templateObject11, Theme.colors.blueGrey);

export var Clear = styled.i.attrs(function (props) {
  return {
    className: 'fa fa-close fa-sm'
  };
})(_templateObject12, Theme.colors.blueGrey);

export var Bars = styled.i.attrs(function (props) {
  return {
    className: 'fa fa-bars'
  };
})(_templateObject13, Theme.colors.pearlGrey);

export var SortableHandler = sortableHandle(function (_ref) {
  var value = _ref.value;
  return React.createElement(
    SortableHandlerBox,
    null,
    React.createElement(Bars, null),
    React.createElement(
      ListItemLabel,
      null,
      value
    )
  );
});

export var SortableItem = sortableElement(function (_ref2) {
  var id = _ref2.id,
      value = _ref2.value,
      removeHandler = _ref2.removeHandler;
  return React.createElement(
    ListItem,
    { key: id },
    React.createElement(SortableHandler, { value: value }),
    React.createElement(RemoveAction, { onClick: removeHandler })
  );
});

export var SortableContainer = sortableContainer(function (_ref3) {
  var children = _ref3.children;

  return React.createElement(
    List,
    null,
    children
  );
});

export var OptionBox = styled.li(_templateObject14, Theme.colors.lightgrey);

export var Label = styled.span(_templateObject15, Theme.colors.blueGrey);

export var StyledSelectContainer = styled.div(_templateObject16);

// Styles that should be provided to a react-select via the 'styles' prop
export var SelectStyles = {
  control: function control(provided) {
    return _extends({}, provided, {
      width: '100%',
      borderRadius: 0,
      height: 48
    });
  }
};